import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLoginLogout = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#FF9800' rx={6} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='m16.76 18.965 1.92-1.92-1.92-1.92M11 17.045h7.628'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M17 11c3.315 0 6 2.25 6 6s-2.685 6-6 6'
    />
  </svg>
);
export default SvgLoginLogout;
